// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OfferCollectionResponse

export type OfferCollectionApiResponse = {
	id: string;
	name: string;
	description: string;
	color: string;
	sortOrder: number;
	logo: string | null;
	offers: string[];
};

export type OfferCollection = {
	id: string;
	name: string;
	description: string;
	color: string;
	sortOrder: number;
	logo: string | null;
	offers: string[];
};

export function hydrateOfferCollection(data: OfferCollectionApiResponse): OfferCollection {
	return { ...data };
}